"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getObjType = exports.get = exports.deepClone = void 0;
require("core-js/modules/es.array.push.js");
const getObjType = obj => {
  const toString = Object.prototype.toString;
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  if (obj instanceof Element) {
    return 'element';
  }
  return map[toString.call(obj)];
};
/**
 * 对象深拷贝
 */
exports.getObjType = getObjType;
const deepClone = data => {
  const type = getObjType(data);
  let obj;
  if (type === 'array') {
    obj = [];
  } else if (type === 'object') {
    obj = {};
  } else {
    // 不再具有下一层次
    return data;
  }
  if (type === 'array') {
    for (let i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]));
    }
  } else if (type === 'object') {
    for (const key in data) {
      obj[key] = deepClone(data[key]);
    }
  }
  return obj;
};

/**
 * 对象取值
 * @param {Object} obj
 * @param {String} path
 */
exports.deepClone = deepClone;
const get = (obj, path, defaultValue) => {
  const paths = path.split('.');
  let current = obj;
  let i;
  for (i = 0; i < paths.length; ++i) {
    if (current[paths[i]] === undefined) {
      return defaultValue;
    }
    current = current[paths[i]];
  }
  return current;
};
exports.get = get;